module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', [_c('b-row', [_c('b-col', [_c('ais-search-box', {
    staticClass: "mb-3",
    attrs: {
      "search-store": _vm.searchStore
    }
  }, [_c('ais-input', {
    attrs: {
      "search-store": _vm.searchStore,
      "placeholder": "Search for venue",
      "class-names": {
        'ais-input': 'form-control'
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('ais-index', {
    attrs: {
      "search-store": _vm.searchStore,
      "index-name": "venues"
    }
  }, [_c('ais-results', {
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('b-row', _vm._l((_vm.results), function(result) {
            return _c('b-col', {
              key: result.objectID,
              attrs: {
                "cols": "12",
                "md": "6",
                "lg": "4"
              }
            }, [_c('router-link', {
              attrs: {
                "to": {
                  name: 'VenueView',
                  params: {
                    key: result.objectID
                  }
                }
              }
            }, [_c('div', {
              staticClass: "text-center mb-3 card text-white"
            }, [_c('img', {
              staticClass: "card-img",
              attrs: {
                "src": result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_288,h_192,c_fill'),
                "srcset": result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_288,h_192,c_fill') + ' 320w,' +
                  result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_576,h_384,c_fill') + ' 640w,' +
                  result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_462,h_308,c_fill') + ' 992w,' +
                  result.pictures[0].secure_url.replace(/v[0-9]+/, 'w_312,h_208,c_fill') + ' 1024w',
                "alt": result.name
              }
            }), _vm._v(" "), _c('div', {
              staticClass: "card-body card-img-overlay"
            }, [_c('h4', {
              staticClass: "card-title"
            }, [_vm._v(_vm._s(result.name))]), _vm._v(" "), (!result._rankingInfo.promoted) ? _c('span', [_vm._v("\n                    <" + _vm._s(Math.ceil(result._rankingInfo.geoDistance / 100) * 100) + "m\n                  ")]) : _vm._e()])])])], 1)
          }))
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d81e8f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 660
// module chunks = 1